var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex flex-col"},_vm._l((4),function(i){return _c('div',{staticClass:"w-full skeleton skeleton-list-item mb-4"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }